import Booking from "./Booking";
import Testimonials from "./Testimonials";
export default function Dining() {
    return (
      <>
      <div className="dining-page" id="dining-page">
    
        <section className="inner-banner-area rooms-hero">
          <img src="img/room-hero-banner.avif" className="w-100" />
          <div className="container">
            <div className="contact-banner">
                <div className="text-center">
                <h2 class="inner-banner-heading">Dining</h2>
                    <nav aria-label="breadcrumb" class="banner-breadcrumb">
                        <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="index.php">Home</a></li>
                        <li class="breadcrumb-item active" aria-current="page">Dining</li>
                        </ol>
                    </nav>
                </div>
            </div>
            </div>
        </section>

        <Booking></Booking>

        <section class="section-margin section-margin--small">
    <div class="container">
        <div class="section-intro text-center pb-80px">
            <h1 class="inner-section-main-heading">Indulge in a Luxurious and Delightful Private Dining in Delhi</h1>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-10">
            <div class="cta-box-content text-center">
              {/* <h3 class="cta-heading mb-4">Celebrate Precious Moments at Our Venues In Vasant Kunj</h3> */}
                <p>The Grand New Delhi's restaurant provides a unique experience of private dining in Delhi, with a variety of scrumptious cuisines ranging from authentic Chinese to Italian to Continental. Located in the vibrant city and close to Aerocity, the menus of all our restaurants at our elegant 5-star hotel have been carefully prepared by our skilled chefs to offer the best fine dining experiences.</p>
            </div>
          </div>
        </div>
        
    </div>
</section>



<section class="home-mid-sec">
  <div class="container-fluid p-0">
    <div class="row repeated-block">
      <div class="col-lg-5 align-self-center text-column">
        <div class="text-box-block">
          <h4 class="text-block-title">
           DKK - Dilli Kanteen Kitchen
          </h4>
          <p><strong>DKK - Dilli Kanteen Kitchen</strong> </p>
          <p><strong>Timings:</strong> 07:00 AM - 11:30 PM</p>
          <p><strong>Kindly call us at +91 11 4766 1200 for more information.</strong> </p>
         
          <p>(Subjected to change as per COVID-19 guidelines)</p>
          <div class="text-box-btns">
            <a href="#" class="btn explore-more-hero">Book Now</a>
           {/* <a href="#" class="btn explore-more-hero">Explore More</a> */} 
          </div>
          
        </div>
      </div>
      <div class="col-lg-7 p-0 image-column">
        <div class="img-block">
          <img src="img/dkk.avif" class="w-100" alt="Studio Apartments" />
        </div>
      </div>
    </div>

    <div class="row repeated-block">
      <div class="col-lg-5 align-self-center text-column">
        <div class="text-box-block">
          <h4 class="text-block-title">
             Cascades at The Grand New Delhi
          </h4>
          <p>Situated on the lobby level of the hotel, Cascades is one of the best lounges in Delhi and the place to see-and-be-seen. Guests will be delighted by the panoramic views that look out onto lush landscaped garden and beautiful water bodies. Ideal for a business engagement and friendly gatherings over the cup of tea or coffee.</p>

          <p><strong>Location: </strong> Lobby level</p>
          <p><strong>Timing:</strong> 10:00 am - 11:00 pm</p>
          
          <p>(Subjected to change as per COVID-19 guidelines)</p>
          <div class="text-box-btns">
            {/* <a href="#" class="btn explore-more-hero">Explore More</a> */} 
            <a href="#" class="btn book-now-hero" id="book-now">Book Now</a>
          </div>
        </div>
      </div>
      <div class="col-lg-7 p-0 image-column">
        <div class="img-block">
          <img src="img/cascades.avif" class="w-100" alt="wedding and events" />
        </div>
      </div>
      
    </div>

    <div class="row repeated-block">
      <div class="col-lg-5 align-self-center text-column">
        <div class="text-box-block">
          <h4 class="text-block-title">
             GBar - The high-energy bar in New Delhi
          </h4>
          <p>GBar is our super-deluxe all-day lounge and cocktail bar, serving the best selection of wines, champagnes and cocktails and alcohol in Delhi with soulful music to give you an experience of your lifetime.</p>
          
          <p><strong>Location: </strong> Lobby level</p>
          <p><strong>Timing:</strong> 01:00 pm - 01:00 am</p>
          <p><strong>Kindly call us at +91 11 4766 1200 for more information.</strong> </p>
          
          <p>(Subjected to change as per COVID-19 guidelines)</p>
          <div class="text-box-btns">
            {/* <a href="#" class="btn explore-more-hero">Explore More</a> */} 
            <a href="#" class="btn book-now-hero" id="book-now">Book Now</a>
          </div>
        </div>
      </div>
      <div class="col-lg-7 p-0 image-column">
        <div class="img-block">
          <img src="img/g-bar.avif" class="w-100" alt="wedding and events" />
        </div>
      </div>
      
    </div>

    <div class="row repeated-block">
      <div class="col-lg-5 align-self-center text-column">
        <div class="text-box-block">
          <h4 class="text-block-title">
             Aqua - A Rejuvenating Pool Side Bar in New Delhi
          </h4>
          <p>Enjoy a relaxed al fresco experience at our Aqua Bar, at the finest 5-star hotel in New Delhi. It is one of the best poolside bars in New Delhi. Soak in the sun with a healthy continental menu served along with a wide range of tantalizing cocktails and mocktails. Experience a magical evening with your loved ones at one of the most happening and luxurious bars in Delhi during your stay at our 5-star hotel near Delhi airport.</p>

          <p><strong>Location: </strong> Pool Side</p>
          <p><strong>Timing:</strong> 10:00 am to 07:00 pm( Temporarily Closed)</p>
          
          <p>(Subjected to change as per COVID-19 guidelines)</p>
          <div class="text-box-btns">
            {/* <a href="#" class="btn explore-more-hero">Explore More</a> */} 
            <a href="#" class="btn book-now-hero" id="book-now">Book Now</a>
          </div>
        </div>
      </div>
      <div class="col-lg-7 p-0 image-column">
        <div class="img-block">
          <img src="img/aqua-bar.avif" class="w-100" alt="wedding and events" />
        </div>
      </div>
      
    </div>

  </div>
</section>




</div>

<Testimonials></Testimonials>

      </>
    );
  }
  